// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"93":"a4de2978","234":"41c36908","264":"ad553438","279":"622ddc40","324":"f5d90c6d","359":"c01919e4","376":"4afa2d9d","453":"0cf64050","660":"94d387a2","954":"6000ef38"}[chunkId] + ".chunk.js";
};